import { EnrollmentStatusTypes } from '@shared/enums';
import { z } from 'zod';

export const enrollmentStatusValidation = z.nativeEnum(EnrollmentStatusTypes);

export const changeEnrollmentStatusValidation = z.object({
  newStatus: enrollmentStatusValidation,
  reason: z.string().optional().default(''),
});
